"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "Line", { enumerable: true, get: function () { return rpdf_renderer_1.Line; } });
//# sourceMappingURL=line.js.map